/**
 * @desc 获取渠道商收款信息
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<Array<defs.tms.LogisticsProviderPaymentTobResponseDto>>;
export function request(providerCode: string | number, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/logisticsProviderTob/getProviderPayment/${providerCode}`, {
      method: "POST",

      ...options,
    }),
  );
}
